import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsForgeAppsRoute: InvariantJiraRoute = {
	name: 'project-settings-software-forge-apps',
	path: '/jira/software/c/projects/:projectKey/settings/apps/:appId/:envId/:route?',
};
